// extracted by mini-css-extract-plugin
export var alignCenter = "_9z-d";
export var bannerShown = "_9z-6";
export var buttonContent = "_9z-0";
export var cardList = "_9z-1";
export var centerContent = "_9z-2";
export var chevron = "_9z-3";
export var closePanelButton = "_9z-k";
export var conversationContextContainer = "_9z-l";
export var conversationDetailContainer = "_9z-4";
export var detailWrapper = "_9z-7";
export var dropdownButton = "_9z-e";
export var dropdownTitle = "_9z-9";
export var fullHeight = "_9z-5";
export var hidden = "_9z-a";
export var icon = "_9z-b";
export var mergeSuggestionWrapper = "_9z-m";
export var panel = "_9z-i";
export var portalButtonsWrapper = "_9z-c";
export var right = "_9z-j";
export var tableSummaryContainer = "_9z-8";
export var tableSummaryHeader = "_9z-g";
export var threeDotsButton = "_9z-f";
export var wide = "_9z-h";